/* eslint-disable */
import VueStoreService from './VueStoreService';

const TransactionService = {
  async getTransactions(store) {
    return await VueStoreService.get('transactions', store);
  },

  async uploadVouchers(store, id, formData) {
    return await VueStoreService.postFile(`transactions/${id}/voucher`, formData, store);
  },

  async getVouchers(id, store) {
    return await VueStoreService.get(`transactions/${id}/vouchers`, store);
  },

  async getVoucherFile(transactionId, voucherId) {
    return `${process.env.APIURL}transactions/${transactionId}/voucher/${voucherId}`;
  },

  async deleteVoucher(store, transactionId, voucherId) {
    return await VueStoreService.delete(`transactions/${transactionId}/voucher/${voucherId}`, store);
  },
};

export default TransactionService;
